export const BackgroundLogin = new URL("./BackgroundLogin.png", import.meta.url)
  .href;

export const Brazil = new URL("./Brazil.svg", import.meta.url).href;

export const China = new URL("./China.svg", import.meta.url).href;

export const Spain = new URL("./Spain.svg", import.meta.url).href;

export const UnitedStatesofAmerica = new URL(
  "./UnitedStatesofAmerica.svg",
  import.meta.url,
).href;

export const GS3Logo = new URL("./GS3Logo.png", import.meta.url).href;

export const Gps404 = new URL("./gps_404.png", import.meta.url).href;

export const LogoDefaultCompanies = new URL(
  "./logo_default_companies.png",
  import.meta.url,
).href;

export const GS3HeaderLogo = new URL("./GS3HeaderLogo.png", import.meta.url)
  .href;
